export const GETNEWSXQ = 'newsDetail/GETNEWSXQ';